import {gettext} from 'topmeteo/utils/i18n';

import {getNextOffset, getPreviousOffset} from '../../general/selectors';

import Button from './ChangeImageButton';

const NextLabel = gettext('next date');
const PreviousLabel = gettext('previous date');

const Buttons = [
    {id: 'prev', label: PreviousLabel, action: getPreviousOffset},
    {id: 'next', label: NextLabel, action: getNextOffset},
];

const SwitchDate = () => Buttons.map(({id, label, action}) => (
    <Button key={id} className={`${id} date`} label={label} action={action} arrows={2} />
));

export default SwitchDate;
